import { render, staticRenderFns } from "./ArchiveButton.vue?vue&type=template&id=2fcbd840"
import script from "./ArchiveButton.vue?vue&type=script&lang=ts"
export * from "./ArchiveButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports